import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/command-center.css';
import './styles/notifications.css';
import './styles/shop-workflow.css';
import './styles/shop-preorders-v2.css';
import './styles/cash-flow.css';
import './styles/cash-flow-actions.css';
import App from './App';
import { installStaffInterceptors } from './staffAuth';

installStaffInterceptors('adminToken');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
